export default __webpack_public_path__ + "static/media/value3.83be03d6.png";